import React from 'react';
import client from '@/lib/feathers';
import axios from 'axios';
import {
  Button,
  message,
  Upload,
  type UploadFile,
  type UploadProps,
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import styles from './index.module.scss';

type UploadLogoProps = {
  fileList: UploadFile[];
  getLogoUrl: (logoUrl: string) => void;
  addFile: (file: UploadFile) => void;
  removeFile: () => void;
};

const UploadLogo = ({
  fileList,
  getLogoUrl,
  removeFile,
  addFile,
}: UploadLogoProps) => {
  const uploadFiles = (dbName: string, file: string | Blob) => {
    const formData = new FormData();
    formData.append('files', file);
    const res = axios.post(
      `/newUploads?type=${dbName}&isConvertPng=false`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          authorization: localStorage.getItem('feathers-jwt'),
        },
      }
    );
    return res;
  };

  const deleteFile = (file: UploadFile<any>) => {
    removeFile();
    getLogoUrl('/ezcon/icon/pink-one/logo.svg');
    return client.service('uploads').remove(file.response._id);
  };

  const customRequest = async (options: { file: any; onSuccess?: any }) => {
    const { onSuccess, file } = options;
    if (file.size > 1024 * 1024 * 20) {
      message.error('上傳檔案不能超過20MB');
      return;
    }
    try {
      const res = await uploadFiles('communityAppTheme', options.file);
      onSuccess(res.data);
      getLogoUrl(res.data.showPath);
      addFile({
        url: res.data.showPath,
        uid: res.data.uid,
        name: res.data.oldName,
        response: {
          _id: res.data._id,
        },
      });
      if (fileList.length !== 0) {
        client.service('uploads').remove(fileList[0].response._id);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const props: UploadProps = {
    name: 'logo',
    maxCount: 1,
    onChange(info) {
      if (info.file.status === 'done') {
        getLogoUrl(info.file.response.showPath);
        message.success(`${info.file.name} 成功上傳！`);
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} 上傳失敗`);
      }
    },
    customRequest,
    accept: 'image/*',
    onRemove: async (file) => {
      try {
        await deleteFile(file);
        message.success('圖片移除成功！');
      } catch (err) {
        console.error({ err });
      }
    },
  };

  return (
    <div className={styles.uploadContainer}>
      <Upload {...props} fileList={fileList}>
        <Button icon={<UploadOutlined />}>上傳logo圖片</Button>
      </Upload>
    </div>
  );
};

export default UploadLogo;
